import { useRecoilState } from 'recoil';
import { bottomBarOpenState } from 'store';
import { useState, useEffect } from 'react';
import BottomBar from './BottomBar';
import { HintButton } from '@/components/tour/regular/bottomBar/BottomBar/styles';

const BottomBarWithRecoil = (props: any) => {
  const [bbIsOpen, setBbIsOpen] = useRecoilState(bottomBarOpenState);
  const condition = window.innerWidth < 1024 && props.measurements;
  const [showBottomBar, setShowBottomBar] = useState(!condition);
  const [showHintButton, setShowHintButton] = useState(condition);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024 && props.measurementsOn) {
        setShowBottomBar(false);
        setShowHintButton(true);
      } else {
        setShowBottomBar(true);
        setShowHintButton(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [props.measurementsOn]);

  return (
    <>
      {showHintButton && (
        <HintButton onClick={() => setShowBottomBar(!showBottomBar)}>
          <i className={`fas ${showBottomBar ? 'fa-angle-down' : 'fa-angle-up'}`} />
        </HintButton>
      )}

      {showBottomBar && <BottomBar {...props} reelOpen={bbIsOpen} setReelOpen={setBbIsOpen} />}
    </>
  );
};

export default BottomBarWithRecoil;
